/**
 * @format
 */
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class TemplateParametersService {
   readonly WRAP_PARAMETER_REG_EXP = new RegExp(
      /<span id="PARAMETER"><template-context(\s|[a-zA-Z]|\d|=|"|:|\\|\$|{|}|\.|,|\(|\)|_|#|!|'|\?|\+|-)*>(<span class="label2 label-info">([a-zA-Z]|\s)*<span>×<\/span><\/span>)*<\/template-context><\/span>/g
   );
   readonly PARAMETER_REG_EXP = new RegExp(
      /<template-context(\s|[a-zA-Z]|\d|=|"|:|\\|\$|{|}|\.|,|\(|\)|_|#|!|'|\?|\+|-)*>(<span class="label2 label-info">([a-zA-Z]|\s)*<span>×<\/span><\/span>)*<\/template-context>/g
   );


   constructor() {}
   getElementWrapped = (element: string): string => `<span id="PARAMETER">${element}</span>`;

   wrapParametersWithSpan(content: string): string {
      let noWrappedInside = this.removeSpanWrapperFromParameter(content);
      let newValue = noWrappedInside;
      const templateContextElements = noWrappedInside.match(this.PARAMETER_REG_EXP);
      if (Boolean(templateContextElements) && templateContextElements.length > 0) {
         const uniqueTemplateContextElements = [...new Set(templateContextElements)];
         uniqueTemplateContextElements.forEach((element) => {
            const regExp = new RegExp(this.escapeText(element), "g");
            newValue = newValue.replace(regExp, this.getElementWrapped(element));
         });
      }

      return newValue;
   }

   removeSpanWrapperFromParameter(text: string) {
      let noWrappedInside = text;
      const wrappedElements = text.match(this.WRAP_PARAMETER_REG_EXP);
      if (Boolean(wrappedElements) && wrappedElements.length > 0) {
         wrappedElements.forEach((wrappedElement) => {
            const noWrappedElements = wrappedElement.match(this.PARAMETER_REG_EXP);
            const regExp = new RegExp(this.escapeText(wrappedElement), "g");
            noWrappedInside = noWrappedInside.replace(regExp, `${noWrappedElements[0]}`);
         });
      }
      return noWrappedInside;
   }

   private escapeText(text: string) {
      text = text.replace(/\$/g, "\\$");
      text = text.replace(/\//g, "\\/");
      text = text.replace(/\./g, "\\.");
      text = text.replace(/\(/g, "\\(");
      text = text.replace(/\)/g, "\\)");
      text = text.replace(/\?/g, "\\?");
      text = text.replace(/\+/g, "\\+");
      return text;
   }
}
